import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CuponsService} from "../../superadmin/services/cupons.service";
import {GridCuponsComponent} from "./grid-cupons/grid-cupons.component";


@Component({
  selector: 'app-tela-cupons',
  templateUrl: './tela-cupons.component.html',
  styleUrls: ['./tela-cupons.component.scss']
})
export class TelaCuponsComponent implements OnInit {
  @ViewChild('gridGruponsAtivos',  {static: true} )  gridGruponsAtivos: GridCuponsComponent;
  @Input() exibirTitulo = true;
  constructor(private cuponsService: CuponsService) {

  }

  ngOnInit(): void {
    this.carregueCuponsAtivos();
  }


  private carregueCuponsAtivos() {
    this.gridGruponsAtivos.carregando = true;
    this.cuponsService.listeCupons({ listavel: true }).then( (resposta) => {
      this.gridGruponsAtivos.setCupons(resposta)
    })
  }

}
